// src/features/testimonial/TestimonialSlider.tsx

'use client'; // This is the interactive island

import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Autoplay } from 'swiper/modules';
import { FaQuoteLeft } from 'react-icons/fa6';
import Image from 'next/image'; // Use the original next/image
import 'swiper/css';
import 'swiper/css/navigation';
import NextImage from '../Image';

// Define the type for a single testimonial for type safety
interface Testimonial {
  id: string | number; // Or a unique identifier
  comment: string;
  avatar: string;
  user_name: string;
}

interface SliderProps {
  testimonials: Testimonial[];
}

export const TestimonialSlider: React.FC<SliderProps> = ({ testimonials }) => {
  return (
    <Swiper
      modules={[Navigation, Autoplay]}
      navigation={{
        nextEl: '.testimonial-next',
        prevEl: '.testimonial-prev',
      }}
      loop={true}
      spaceBetween={30}
      breakpoints={{
        320: { slidesPerView: 1 },
        768: { slidesPerView: 2.5 },
        992: { slidesPerView: 2.5 },
      }}
      className="testimonial__slider"
    >
      {testimonials.map((testimonial) => (
        <SwiperSlide key={testimonial.id}>
          <div className="testimonial__item testimonial__item--style1">
            <div className="testimonial__item-inner">
              <div className="testimonial__item-content">
                <div className="testimonial__quote">
                  <span>
                    <FaQuoteLeft />
                  </span>
                </div>
                <p className="mb-0">{testimonial.comment}</p>
                <div className="testimonial__footer">
                  <div className="testimonial__author">
                    <div className="testimonial__author-thumb">
                      <NextImage
                        fallbackSrc="/images/icon/demo-person.jpg"
                        src={
                          testimonial.avatar || '/images/icon/demo-person.jpg'
                        }
                        alt={`${testimonial.user_name}'s Avatar`}
                        width={80}
                        height={80}
                        className="rounded-circle"
                        sizes="80px" // Add sizes prop for optimized image loading
                      />
                    </div>
                    <div className="testimonial__author-designation">
                      <h6>{testimonial.user_name}</h6>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </SwiperSlide>
      ))}
    </Swiper>
  );
};
